import type { ICellRendererParams } from 'ag-grid-community'
import type { Match } from '../../../../../../api/useSupplierReconciliation/types/match'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'

export function DestinationsCellRenderer({ data }: ICellRendererParams<Match>) {
  return (
    <Vertical>
      {data?.destinations?.map((d) => {
        return (
          <Horizontal gap={3} key={`${d.site_name}-${d.site_number}`}>
            <Texto weight='bold'>{d.site_number},</Texto>
            <Texto>{d.site_name}</Texto>
          </Horizontal>
        )
      })}
    </Vertical>
  )
}
